import Moment from 'moment';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import TagsManager from '@/src/components/project/Tags/TagsManager';
import { RootState } from '@/src/reducers/types';

import { useLibraryListStore } from '../../../../store/library-list.store';
import DeleteSingle from '../Actions/Delete/DeleteSingle';
import Download from '../Actions/Download/Download';
import Ellipsis from '../Actions/Ellipsis/Ellipsis';
import Move from '../Actions/Move/Move';
import { Restore } from '../Actions/Restore/Restore';
import Filename from '../Filename/Filename';

const Item = ({ file, provided, snapshot, isDropDisabled = false }) => {
  const files = useSelector((state: RootState) => state.files);
  const inTrash = files.activeInSidebar.id === 'trash';

  const { projectId } = useParams<{ projectId: string }>();

  const { rowTags, setRowTags } = useLibraryListStore((state) => ({
    rowTags: state.rowTags,
    setRowTags: state.setRowTags,
  }));

  const fileTags = file['tags'];

  useEffect(() => {
    if (!rowTags[file.id] && Array.isArray(fileTags) && fileTags.length > 0) {
      setRowTags({ [file.id]: fileTags });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id, fileTags]);

  let listRowClasses = `columnItem listRow`;
  if (file.status === 'inprogress') listRowClasses += ' uploading ';
  if (snapshot?.isDragging) listRowClasses += ' dragging ';
  if (isDropDisabled) listRowClasses += ' disabled ';

  const uploadedBy = file['uploaded-by'];
  const legacyFile = {
    id: file.id,
    type: file.source,
    name: file.name,
    origin: file.name,
    version: file.version,
    isSelected: file.isSelected,
    'source-id': file['source-id'],
  };
  const itemIdsVersioned = [
    {
      id: legacyFile.id,
      version: legacyFile.version,
    },
  ];

  return (
    <div className="fileListContainer">
      <div className={listRowClasses}>
        <React.Fragment>
          <Filename file={legacyFile} provided={provided} snapshot={snapshot} />
          <div className="listItem">
            <span>{uploadedBy}</span>
          </div>
          <div className="listItem">
            <span>
              {file['uploaded-date'] ? Moment(file['uploaded-date']).format('DD-MMM YYYY') : '--'}
            </span>
          </div>
          <div className="listItem">
            <TagsManager
              isFilesTable={false}
              isLibrary={true}
              projectId={projectId}
              folderId={file.id}
              inboxDocumentId={file.id}
              assignedTags={file.tags || []} // Use file.tags as source of truth
              setAssignedTags={(tags) => {
                // Deduplicate tags by name
                const dedupeTags = (tags) => {
                  const seen = new Set();
                  return tags.filter((tag) => {
                    if (seen.has(tag.name)) return false;
                    seen.add(tag.name);
                    return true;
                  });
                };
                const dedupedTags = dedupeTags(tags);
                // Update file.tags directly for all mutations
                file.tags = dedupedTags;
              }}
            />
          </div>

          {inTrash ? (
            <div className="listItem filesActionContainer">
              <Restore itemIdsVersioned={itemIdsVersioned} />
              <DeleteSingle
                file={legacyFile}
                itemIdsVersioned={itemIdsVersioned}
                inTrash={inTrash}
                showLabel={false}
              />
            </div>
          ) : (
            <div className="listItem filesActionContainer">
              <Move itemIdsVersioned={itemIdsVersioned} />
              <Download itemIds={[legacyFile.id]} />
              {file.source === 'folder' || file.source !== 'folder' ? (
                <Ellipsis file={legacyFile} itemIdsVersioned={itemIdsVersioned} />
              ) : (
                <div className="tw-invisible tw-w-[43px]" />
              )}
            </div>
          )}
        </React.Fragment>
      </div>
    </div>
  );
};

export default Item;
